import type { GroupKey } from './types'

export const GROUP_ORDER: GroupKey[] = [
  'physician_general', 'physician_medical', 'physician_surgical', 'physician_pediatric',
  'physician_mental', 'physician_diagnostic', 'physician_prevention', 'physician_other',
  'dentist', 'pharmacist', 'nurse_midwife', 'paramedic', 'rehabilitation', 'psychology',
  'laboratory', 'public_health', 'dental_mid', 'allied_mid', 'other',
]

const LABELS: Record<GroupKey, { uk: string; en: string }> = {
  physician_general: { uk: 'Лікарі · загальна практика', en: 'Physicians · general practice' },
  physician_medical: { uk: 'Лікарі · терапевтичний профіль', en: 'Physicians · medical' },
  physician_surgical: { uk: 'Лікарі · хірургічний профіль', en: 'Physicians · surgical' },
  physician_pediatric: { uk: 'Лікарі · дитячі спеціальності', en: 'Physicians · pediatric' },
  physician_mental: { uk: 'Лікарі · психіатрія та психологія', en: 'Physicians · mental health' },
  physician_diagnostic: { uk: 'Лікарі · діагностика та лабораторія', en: 'Physicians · diagnostics and laboratory' },
  physician_prevention: { uk: 'Лікарі · профілактика та гігієна', en: 'Physicians · prevention and hygiene' },
  physician_other: { uk: 'Лікарі · інші спеціальності', en: 'Physicians · other' },
  dentist: { uk: 'Стоматологи', en: 'Dentists' },
  pharmacist: { uk: 'Фармацевти', en: 'Pharmacists' },
  nurse_midwife: { uk: 'Медсестри та акушерки', en: 'Nurses and midwives' },
  paramedic: { uk: 'Парамедики та фельдшери', en: 'Paramedics' },
  rehabilitation: { uk: 'Реабілітація', en: 'Rehabilitation' },
  psychology: { uk: 'Психологія та психотерапія', en: 'Psychology and psychotherapy' },
  laboratory: { uk: 'Лабораторна діагностика', en: 'Laboratory' },
  public_health: { uk: "Громадське здоров'я", en: 'Public health' },
  dental_mid: { uk: 'Зубні техніки та гігієністи', en: 'Dental technicians and hygienists' },
  allied_mid: { uk: 'Молодші спеціалісти: лабораторія, профілактика, фармація', en: 'Associate specialists: laboratory, prevention, pharmacy' },
  other: { uk: 'Інші фахівці', en: 'Other professionals' },
}

export function groupLabel(key: GroupKey, language: string): string {
  return LABELS[key][language === 'uk' ? 'uk' : 'en']
}
